import * as mutationTypes from "./mutation-types";
import { getBlankCriteria, getBlankMfaProfileRecord, getBlankRecord } from "./helpers";
import { getBlankNextPreviousInfo } from "@/store/helpers";
import { tableHelper } from "@/helpers/table.helper";

export const state = getInitialState();

export function getInitialState() {
  return {
    listing: {
      criteria: getBlankCriteria(),
      criteriaInfo: tableHelper.getBlankCriteriaInfo(),
      data: [],
      paging: tableHelper.getDefaultPaging("LastLogonDate"),
      loading: false,
      loaded: false
    },
    view: {
      data: getBlankRecord(),
      next: getBlankNextPreviousInfo(),
      previous: getBlankNextPreviousInfo(),
      breadcrumbs: [{ text: "..." }],
      loading: false,
      loaded: false,
      userId: null
    },
    viewMfaProfile: {
      data: getBlankMfaProfileRecord(),
      loading: false,
      loaded: false
    },
    edit: {
      data: getBlankRecord(),
      loading: false,
      saving: false,
      error: {
        show: false,
        details: {},
        hideMutation: mutationTypes.STATE_HIDE_ERROR,
        hideArgument: "edit"
      }
    },
    updateUserMfa: {
      saving: false,
      error: {
        show: false,
        details: {},
        hideMutation: mutationTypes.STATE_HIDE_ERROR,
        hideArgument: "updateUserMfa"
      }
    },
    updateMySecondFactor: {
      saving: false,
      error: {
        show: false,
        details: {},
        hideMutation: mutationTypes.STATE_HIDE_ERROR,
        hideArgument: "updateMySecondFactor"
      }
    },
    setupAuthenticatorMfa: {
      get: {
        data: {},
        loading: false
      },
      setup: {
        data: {},
        saving: false,
        error: {
          show: false,
          details: {},
          hideMutation: mutationTypes.STATE_HIDE_ERROR,
          hideArgument: "setupAuthenticatorMfa"
        }
      }
    },
  };
}

export function getUnloadedState() {
  return {
    listing: {
      loaded: false
    },
    view: {
      loaded: false
    },
    viewMfaProfile: {
      loaded: false
    },
    updateUserMfa: {
      saving: false
    },
    updateMySecondFactor: {
      saving: false
    },
    setupAuthenticatorMfa: {
      get: {
        loaded: false
      },
      setup: {
        saving: false
      }
    }
  };
}
